import React, { Component } from "react";
import CAPEX from "./data/capex.json";
import Tooltip from "./Tooltip";
import ProductDetails from "./ProductDetails";

class Process extends Component {
  constructor(props) {
    super(props);

    const firstCategory = Object.keys(CAPEX)[0];
    const firstStep = CAPEX[firstCategory][0];

    const feedOptions =
      props.feedOptions && props.feedOptions.length
        ? props.feedOptions
        : ["Cultivation output"];

    this.state = {
      feed: feedOptions,
      selectedFeed: feedOptions[0],
      processId: this.props.processId,

      selectedProcessingStep: firstStep,
      products: [...firstStep.products],

      capexValue: 0,
      opexValue: 0,
      installedCost: 0,

      userEditedCapex: false,
      userEditedOpex: false,
    };
  }

  componentDidMount() {
    const { selectedProcessingStep } = this.state;
    const { onProcessChange, onProcessMetadata, processIndex } = this.props;

    if (onProcessChange && selectedProcessingStep) {
      onProcessChange(processIndex, {
        numProducts: selectedProcessingStep.num_of_products,
        products: [...selectedProcessingStep.products],
      });
    }

    if (onProcessMetadata && selectedProcessingStep) {
      onProcessMetadata(processIndex, {
        step: selectedProcessingStep.step,
        capacity: selectedProcessingStep.capacity,
        invesment: selectedProcessingStep.invesment,
        conversion_factor: selectedProcessingStep.conversion_factor,
        n: selectedProcessingStep.n,
        langfactor: selectedProcessingStep.langfactor,
      });
    }

    this.computeCapexOpex();
  }

  componentDidUpdate(prevProps, prevState) {
    // feed options update
    if (prevProps.feedOptions !== this.props.feedOptions) {
      const feedOptions =
        this.props.feedOptions && this.props.feedOptions.length
          ? this.props.feedOptions
          : ["Cultivation output"];

      this.setState({
        feed: feedOptions,
        selectedFeed: feedOptions[0],
      });
    }

    // if process definition changed, update products & metadata
    if (
      prevState.selectedProcessingStep !== this.state.selectedProcessingStep
    ) {
      const { selectedProcessingStep } = this.state;

      this.setState({
        products: [...selectedProcessingStep.products],
      });

      if (this.props.onProcessMetadata && selectedProcessingStep) {
        this.props.onProcessMetadata(this.props.processIndex, {
          step: selectedProcessingStep.step,
          capacity: selectedProcessingStep.capacity,
          invesment: selectedProcessingStep.invesment,
          conversion_factor: selectedProcessingStep.conversion_factor,
          n: selectedProcessingStep.n,
          langfactor: selectedProcessingStep.langfactor,
        });
      }
    }

    // recalc economics when capacity or step changes
    if (
      prevProps.currentCapacity !== this.props.currentCapacity ||
      prevProps.operatingHoursPerYear !== this.props.operatingHoursPerYear ||
      prevState.selectedProcessingStep !== this.state.selectedProcessingStep
    ) {
      this.computeCapexOpex();
    }
  }

  // -------------------------------------------------------------
  // CAPEX/OPEX CALC
  // -------------------------------------------------------------
  computeCapexOpex = () => {
    const { selectedProcessingStep } = this.state;
    const { currentCapacity, operatingHoursPerYear } = this.props;

    if (!selectedProcessingStep) return;

    const RC = Number(selectedProcessingStep.capacity);
    const I =
      (Number(selectedProcessingStep.invesment)) * 1000;
    const F = Number(selectedProcessingStep.conversion_factor);
    const EX = Number(selectedProcessingStep.n);
    const LF = Number(selectedProcessingStep.langfactor);
    const O = Number(selectedProcessingStep.OPEX);

    const CC =
      (Number(currentCapacity)) /
      (Number(operatingHoursPerYear));

    let CAPEX = 0;
    if (RC > 0 && I > 0 && CC > 0) {
      const scale = (CC * F) / RC;      
      CAPEX = I * Math.pow(scale, EX);
      console.log(Number(selectedProcessingStep.n), EX, scale,  CAPEX);
    }

    const Installed = LF * CAPEX;
    const OPEX = CAPEX * O;

    this.setState(
      (prev) => ({
        capexValue: prev.userEditedCapex
          ? prev.capexValue
          : Number(CAPEX.toFixed(2)),
        opexValue: prev.userEditedOpex
          ? prev.opexValue
          : Number(OPEX.toFixed(2)),
        installedCost: Number(Installed.toFixed(2)),
      }),
      () => {
        if (this.props.onCapexUpdate) {
          this.props.onCapexUpdate(this.props.processIndex, {
            capex: Number(CAPEX.toFixed(2)),
            installed: Number(Installed.toFixed(2)),
            opex: Number(OPEX.toFixed(2)),
          });
        }
      }
    );
  };

  // -------------------------------------------------------------
  // SELECT PROCESS FROM CAPEX.json
  // -------------------------------------------------------------
  updateSelectedStep = (e) => {
    const temp = e.target.value.split(":::");
    const pstep = temp[0].trim();
    const ptype = temp[1].trim();

    const selectedProcessingStepArr = CAPEX[pstep].filter(
      (a) => a.step.toLowerCase() === ptype.toLowerCase()
    );
    const selectedProcessingStep = selectedProcessingStepArr[0];

    this.setState(
      {
        selectedProcessingStep,
        products: [...selectedProcessingStep.products],
        userEditedCapex: false,
        userEditedOpex: false,
      },
      () => {
        if (this.props.onProcessChange) {
          this.props.onProcessChange(this.props.processIndex, {
            numProducts: selectedProcessingStep.num_of_products,
            products: [...selectedProcessingStep.products],
          });
        }

        if (this.props.onProcessMetadata) {
          this.props.onProcessMetadata(this.props.processIndex, {
            step: selectedProcessingStep.step,
            capacity: selectedProcessingStep.capacity,
            invesment: selectedProcessingStep.invesment,
            conversion_factor: selectedProcessingStep.conversion_factor,
            n: selectedProcessingStep.n,
            langfactor: selectedProcessingStep.langfactor,
          });
        }

        this.computeCapexOpex();
      }
    );
  };

  // -------------------------------------------------------------
  // FEED SELECTION
  // -------------------------------------------------------------
  handleFeedChange = (e) => {
    const value = e.target.value;
    this.setState({ selectedFeed: value });
    if (this.props.onFeedChange) {
      this.props.onFeedChange(this.props.processIndex, value);
    }
  };

  // -------------------------------------------------------------
  // YIELD CALLBACK
  // -------------------------------------------------------------
  handleProductYieldChangeForProduct = (productName, yld) => {
    if (this.props.onProductYieldChange) {
      this.props.onProductYieldChange(
        this.props.processIndex,
        productName,
        yld
      );
    }
  };

  // -------------------------------------------------------------
  // USER OVERRIDES CAPEX/OPEX
  // -------------------------------------------------------------
  handleCapexInput = (e) => {
    const val = e.target.value;
    this.setState({
      capexValue: val === "" ? "" : Number(val),
      userEditedCapex: true,
    });
  };

  handleFinalProductChange = (productName, isFinal) => {
    this.props.onFinalProductChange &&
      this.props.onFinalProductChange(
        this.props.processIndex,
        productName,
        isFinal
      );
  };

  handleProductPriceChange = (productName, price) => {
    this.props.onProductPriceChange &&
      this.props.onProductPriceChange(
        this.props.processIndex,
        productName,
        price
      );
  };

  handleOpexInput = (e) => {
    const val = e.target.value;
    this.setState({
      opexValue: val === "" ? "" : Number(val),
      userEditedOpex: true,
    });
  };

  // -------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------
  render() {
    const {
      products,
      processId,
      feed,
      selectedFeed,
      selectedProcessingStep,
      capexValue,
      opexValue,
    } = this.state;

    const isFirst = processId === 1;
    const isLast = this.props.isLast;
    const showFeedSelector = this.props.showFeedSelector;

    const _CAPEX = {
      title: "Capital Expenditure",
      description:
        "Scaled investment cost for this process step, including equipment.",
    };

    const _OPEX = {
      title: "Operational Expenditure",
      description:
        "Yearly operating cost depending on process scale.",
    };




    return (
      <div className="flex gap-4 mt-4">
        {/* PIPELINE CONNECTOR */}
        <div className="flex flex-col items-center">
          {!isFirst && <div className="w-1 bg-gray-300 h-4" />}
          <div className="w-4 h-4 bg-green-700 rounded-full border-2 border-white shadow" />
          {!isLast ? (
            <div className="w-1 bg-gray-300 flex-1" />
          ) : (
            <div className="w-1 h-4 bg-gray-300" />
          )}
        </div>

        {/* PROCESS CARD */}
        <div className="flex-1 border rounded-xl shadow-sm bg-white p-4 relative">
          {/* HEADER */}
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-semibold text-gray-800">
              Process {processId}: {selectedProcessingStep.step}
            </h3>

            <button
              onClick={() =>
                this.props.onDelete && this.props.onDelete(processId)
              }
              className="p-1 text-red-600 hover:text-red-800 hover:bg-red-50 rounded transition"
              title="Remove this process step"
              type="button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <title>Remove Process</title>
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* MASS FLOW INFO */}
          <div className="bg-blue-50 border border-blue-200 rounded-md p-3 mb-4">
            <h4 className="text-blue-900 font-semibold text-sm mb-1">
              Mass Flow
            </h4>
            <div className="text-sm text-blue-800">
              <div>
                <span className="font-medium">Current Capacity:</span>{" "}
                {this.props.currentCapacity
                  ? `${this.props.currentCapacity.toLocaleString()} ton/year`
                  : "—"}
              </div>
              {showFeedSelector && (
                <div className="mt-1">
                  <span className="font-medium">Feed Stream:</span>{" "}
                  {selectedFeed}
                </div>
              )}
            </div>
          </div>

          {/* FEED SELECTOR */}
          {showFeedSelector && (
            <div className="mb-3">
              <label className="font-medium mt-2 block">Select Feed</label>
              <select
                className="w-full border p-1 rounded"
                value={selectedFeed}
                onChange={this.handleFeedChange}
              >
                {feed.map((f, idx) => (
                  <option key={idx} value={f}>
                    {f}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* PROCESS SELECTOR */}
          <div className="mb-3">
            <label className="font-medium mt-2 block">Select Process</label>
            <select
              id={"processing_step_" + processId}
              className="w-full border p-1 rounded"
              onChange={this.updateSelectedStep}
            >
              {Object.keys(CAPEX).map((k) => (
                <optgroup key={k} label={k}>
                  {CAPEX[k].map((item) => (
                    <option
                      key={k + ":::" + item.step}
                      value={k + ":::" + item.step}
                    >
                      {item.step}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>

          {/* CAPEX / OPEX */}
          <div className="mb-4 mt-4">
            <div>
              <label
                htmlFor={"CAPEX_" + processId}
                style={{ width: "95px", display: "inline-block" }}
              >
                CAPEX <Tooltip key="CAPEX" data={_CAPEX} />
              </label>
              <input
                type="number"
                id={"CAPEX_" + processId}
                className="px-2 border rounded"
                value={capexValue === "" ? "" : capexValue}
                onChange={this.handleCapexInput}
              />{" "}
              EUR
            </div>

            <div className="mt-3">
              <label
                htmlFor={"OPEX_" + processId}
                style={{ width: "95px", display: "inline-block" }}
              >
                OPEX <Tooltip key="OPEX" data={_OPEX} />
              </label>
              <input
                type="number"
                id={"OPEX_" + processId}
                className="px-2 border rounded"
                value={opexValue === "" ? "" : opexValue}
                onChange={this.handleOpexInput}
              />{" "}
              EUR/year
            </div>
          </div>

          {/* PRODUCTS */}
          <div className="mt-3">
            {Array.isArray(products) && products.length > 0 ? (
              products.map((productName, idx) => (
                <ProductDetails
                  key={productName + "_" + idx}
                  productId={idx + 1}
                  productCat={productName}
                  PRODUCTS={this.props.productsList}
                  onYieldChange={this.handleProductYieldChangeForProduct}
                  onFinalProductChange={this.handleFinalProductChange}
                  onPriceChange={this.handleProductPriceChange}
                />
              ))
            ) : (
              <div className="text-sm text-gray-500">
                No products defined
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Process;
